const i18Prefix = 'gopuff.driver_scheduling_manager_ui.translations';

export { i18Prefix };
